import getEventHandlerResize from '../ResizeHandler';

const ACTIVE_TAB = 'bfv-tab-switch--active';
const INACTIVE_CONTENT = 'bfv-tab-switch__content--inactive';

export default class Switch {
  constructor(options = {}) {
    this.$root = options.element;
    this.tabs = this.$root.querySelectorAll('.js-bfv-tab-switch__tab');
    this.tabContent = this.$root.querySelectorAll('.js-bfv-tab-switch__content');
    this.tabNumber = 0;
    this.currentBreakpoint = '';
    this.tabContentLeftSide = [];
    this.tabContentRightSide = [];
  }

  init() {
    this.splitRightAndLeftContent();
    this.checkCurrentBreakpointAndHandleContentRepresentation();
    this.bindEvents();
  }

  bindEvents() {
    Array.prototype.slice.call(this.tabs).forEach(($tab, index) => {
      $tab.addEventListener('click', () => {
        this.tabNumber = index;
        this.showTabContent();
      });
    });

    window.addEventListener('resize', () => {
      this.checkCurrentBreakpointAndHandleContentRepresentation();
    });
  }

  /**
   * the function checks in breakpoint xs the current tab and set an 'active' class for the current tab
   */
  initializeTabsInXS() {
    this.setCurrentTab();
    this.handleTabContent();
  }


  setCurrentTab() {
    const $tab = this.tabNumber;
    this.tabs[$tab].classList.add(ACTIVE_TAB);
  }

  handleTabContent() {
    if (this.tabNumber !== 0) {
      this.collapseLeftContent();
      this.showRightContent();
    } else {
      this.collapseRightContent();
      this.showLeftContent();
    }
  }

  showTabContent() {
    const $tabNumber = this.tabNumber;
    Array.prototype.slice.call(this.tabs).forEach(($tab, index) => {
      $tab.classList.remove(ACTIVE_TAB);

      if (index === $tabNumber) {
        $tab.classList.add(ACTIVE_TAB);
      }
    });

    this.handleTabContent();
  }

  /**
   * The function checks the current viewport. Depending on the viewport, it shows or hides the tab switch and handles the depiction of the content.
   */
  checkCurrentBreakpointAndHandleContentRepresentation() {
    this.currentBreakpoint = getEventHandlerResize().getCurrentViewport();

    if (this.currentBreakpoint === 'XSMALL') {
      this.initializeTabsInXS();
    } else {
      this.showLeftContent();
      this.showRightContent();
      this.removeAllActiveClasses();
    }
  }

  splitRightAndLeftContent() {
    for (let i = 0; i < this.tabContent.length; i += 1) {
      if (Switch.isEven(i)) {
        this.tabContentLeftSide.push(this.tabContent[i]);
      } else {
        this.tabContentRightSide.push(this.tabContent[i]);
      }
    }
  }

  static isEven($value) {
    return ($value % 2 === 0);
  }

  collapseLeftContent() {
    Array.prototype.slice.call(this.tabContentLeftSide).forEach(($tab) => {
      $tab.classList.add(INACTIVE_CONTENT);
    });
  }

  collapseRightContent() {
    Array.prototype.slice.call(this.tabContentRightSide).forEach(($tab) => {
      $tab.classList.add(INACTIVE_CONTENT);
    });
  }

  showLeftContent() {
    this.tabNumber = 0;
    Array.prototype.slice.call(this.tabContentLeftSide).forEach(($tab) => {
      $tab.classList.remove(INACTIVE_CONTENT);
    });
  }

  showRightContent() {
    Array.prototype.slice.call(this.tabContentRightSide).forEach(($tab) => {
      $tab.classList.remove(INACTIVE_CONTENT);
    });
  }

  removeAllActiveClasses() {
    Array.prototype.slice.call(this.tabs).forEach(($tab) => {
      $tab.classList.remove(ACTIVE_TAB);
    });

    Array.prototype.slice.call(this.tabContent).forEach(($tab) => {
      $tab.classList.remove(INACTIVE_CONTENT);
    });
  }
}
